import { useState } from 'react';
import { faqItems } from '@/mocks/faq';

export default function FAQ() {
  const [openId, setOpenId] = useState<string | null>(null);

  const toggle = (id: string) => {
    setOpenId(openId === id ? null : id);
  };

  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-50">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900">
            常见问题
          </h2>
          <p className="mt-3 text-sm text-foreground-600">
            你想知道的，都在这里
          </p>
        </div>

        <div className="space-y-3">
          {faqItems.map((item) => (
            <div
              key={item.id}
              className="rounded-lg bg-background-100 overflow-hidden"
            >
              <button
                onClick={() => toggle(item.id)}
                className="w-full flex items-center justify-between p-5 text-left cursor-pointer hover:bg-background-200/50 transition-colors"
              >
                <span className="text-sm font-medium text-foreground-900 pr-4">
                  {item.question}
                </span>
                <span className="flex-shrink-0 w-6 h-6 flex items-center justify-center">
                  <i
                    className={`text-foreground-500 transition-transform duration-300 ${
                      openId === item.id ? 'ri-subtract-line' : 'ri-add-line'
                    }`}
                  ></i>
                </span>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openId === item.id ? 'max-h-96 pb-5' : 'max-h-0'
                }`}
              >
                <p className="px-5 text-sm text-foreground-600 leading-relaxed">
                  {item.answer}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}